export default __webpack_public_path__ + "static/media/university_phone.74d8dd1d.png";